module.exports = __webpack_public_path__ + "media/images/calendar-72585ffcb0845c9436844e482c74e46e.png";